// extracted by mini-css-extract-plugin
export default {"preview":"jsPNh","landscape":"l8RRX","portrait":"PHCyc","content":"RRycX","image":"TTPnQ"};